// usePresenceUpdate.ts
// Hook to update and broadcast player presence changes
import { useCallback } from 'react';

export function usePresenceUpdate({ presenceChannel, userId }: any) {
  const updatePresence = useCallback(async (isReady: boolean) => {
    if (!presenceChannel.current || !userId) return false;
    try {
      // Update presence state for this user
      await presenceChannel.current.track({
        user_id: userId,
        is_ready: isReady,
        online_at: new Date().toISOString(),
      });
      // Broadcast the change to other clients
      await presenceChannel.current.send({
        type: 'broadcast',
        event: 'presence-updated',
        payload: { user_id: userId, is_ready: isReady },
      });
      return true;
    } catch (err) {
      // Optionally log error here
      return false;
    }
  }, [presenceChannel, userId]);

  return { updatePresence };
}
